import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { StyledFilterChip } from 'views/root/views/home/views/settings/views/ProjectManagement/connected-components/PMConfiguration/components/PMEntities/components/FilterChip';

export const StyledFilters = styled.div`
  position: absolute;
  min-height: 52px; // match pagination height
`;

export const StyledFilter = styled.div`
  & ${StyledFilterChip} {
    border-radius: 4px;
    border-color: ${getColor('botticelli')};
    padding: 1rem;
    background: ${getColor('white')};
  }
`;
